/**
 * A common set of functions for formatting date and time
 */
export const dateAndTimeMixin = {
  methods: {
    /**
     * Method for returning a formatted date if dayOfMonth, month and year are given
     * @param {Object} param
     */
    formatDate({ dayOfMonth, month, year }) {
      // Step 1: Format year
      const yearFormatted =
        year < 1000
          ? year < 100
            ? year < 10
              ? "000" + year
              : "00" + year
            : "0" + year
          : "" + year;

      // Step 2: Format month
      const monthFormatted = month < 9 ? "0" + (month + 1) : "" + (month + 1);

      // Step 3: Format dayOfMonth
      const dayFormatted = dayOfMonth < 10 ? "0" + dayOfMonth : "" + dayOfMonth;

      // Step 4: Return result
      return yearFormatted + "-" + monthFormatted + "-" + dayFormatted;
    },
    /**
     * Get 24 hour time
     */
    get24HrTime(hr, min, tt) {
      hr = tt === 1 ? hr + 12 : hr;
      return {
        hr,
        min
      };
    },
    /**
     * A general function for returning formatted time when hour and mins is given
     * @param {*} hr
     * @param {*} min
     */
    formatTimeOnlyTime(hr, min) {
      let time = hr === 0 ? 12 : hr;
      if (min < 10) {
        time = time + ":0" + min;
      } else {
        time = time + ":" + min;
      }
      return time;
    },
    /**
     * A general function for returning formatted time when hour mins and tt is given
     * @param {Number} hr
     * @param {Number} min
     * @param {Number} tt
     */
    formatTime(hr, min, tt) {
      let time = this.formatTimeOnlyTime(hr, min);
      tt = tt === 0 ? "AM" : "PM";
      return time + " " + tt;
    },
    /**
     * Function to format time in 24 hour format
     * @param {Number} hr
     * @param {Number} min
     */
    formatTime24(hr, min) {
      hr = hr < 10 ? "0" + hr : "" + hr;
      min = min < 10 ? "0" + min : "" + min;
      return hr + ":" + min;
    },
    /**
     * Function to beautify date to show to users
     * @param {String} date - format yyyy-mm-dd
     */
    beautifyDate(date) {
      const dateArray = date.split("-");
      const myDate = new Date(
        parseInt(dateArray[0]),
        parseInt(dateArray[1]) - 1,
        parseInt(dateArray[2])
      );

      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];

      return (
        daysOfWeek[myDate.getDay()] +
        ", " +
        months[parseInt(dateArray[1]) - 1] +
        " " +
        dateArray[2] +
        ", " +
        dateArray[0]
      );
    },
    /**
     *
     * @param {Number} hh
     * @param {Number} tt
     */
    getTimeList(hh, tt, timeList, noReq) {
      tt = hh === 0 ? (tt === 0 ? 1 : 0) : tt;
      if (!noReq) {
        hh = hh === 0 ? 11 : hh - 1;
      }

      for (let i = 0; i < 2; i++) {
        let ttWord = tt === 0 ? "AM" : "PM";
        timeList.push((hh === 0 ? 12 : hh) + " " + ttWord);
        tt = hh === 11 ? (tt === 0 ? 1 : 0) : tt;
        hh = hh === 11 ? 0 : hh + 1;
      }
    },
    /**
     * When date is changed
     */
    changeDate(event) {
      // Step 1: Generate the proper format for setting the date
      const date = event.target.value.split("-");
      const year = parseInt(date[0]);
      const month = parseInt(date[1]) - 1;
      const day = parseInt(date[2]);

      // Step 2: Setting the date in the global vue js state
      this.setDate({
        dayOfMonth: day,
        month: month,
        year: year
      });
    }
  }
};
